<template>
  <div class="card-body">
    <div class="row" v-if="entidad_data">
      <!-- Div Entidad -->
      <div
        :class="
          type_entidad == 'Viaje'
            ? 'col-md-6 col-sm-12 col-xs-12'
            : 'col-md-12 col-sm-12 col-xs-12'
        "
      >
        <div class="card card-info card-outline collapsed-card">
          <div class="card-header pt-2 pb-2">
            <h3 class="card-title">
              <i class="fa fa-truck text-secondary"></i> {{ type_entidad }}
            </h3>
            <div class="card-tools">
              <button
                type="button"
                data-card-widget="collapse"
                data-toggle="tooltip"
                title="Collapse"
                class="btn btn-tool"
              >
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <label for="id_viaje_info" class="col-md-4 col-sm-4 col-xs-6"
                ><b>No:</b></label
              >
              <span
                id="id_viaje_info"
                class="col-md-8 col-sm-8 col-xs-6 text-right"
                >{{ entidad_data.id }}</span
              >
            </div>
            <div class="row">
              <label
                for="No_Orden_Cargue_info"
                class="col-md-4 col-sm-4 col-xs-6"
                ><b>No. Orden Cargue: </b></label
              >
              <span
                id="No_Orden_Cargue_info"
                class="col-md-8 col-sm-8 col-xs-6 text-right"
                >{{
                  type_entidad == "Viaje"
                    ? entidad_data.orden_de_cargue
                    : entidad_data.orden_cargue
                }}</span
              >
            </div>
            <div class="row">
              <label for="Estado_info" class="col-md-4 col-sm-4 col-xs-6"
                ><b>Estado: </b></label
              >
              <span
                id="Estado_info"
                class="col-md-8 col-sm-8 col-xs-6 text-right"
              >
                {{ entidad_data.nEstado }}
              </span>
            </div>
            <div class="row" v-if="type_entidad == 'Viaje'">
              <label
                for="Sitio_Descargue_info"
                class="col-md-4 col-sm-4 col-xs-6"
                ><b>Despachado A: </b></label
              >
              <span
                id="Sitio_Descargue_info"
                class="col-md-8 col-sm-8 col-xs-6 text-right"
              >
                {{ entidad_data.ruta ? entidad_data.ruta.despachadoA : "" }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- Detalle la ruta -->
      <div class="col-md-6 col-sm-12 col-xs-12" v-if="type_entidad == 'Viaje'">
        <div
          class="card card-outline collapsed-card"
          :class="entidad_data.ruta ? 'card-info' : 'card-danger'"
        >
          <div class="card-header pt-2 pb-2">
            <h3 class="card-title">
              <i class="fa fa-map text-secondary"></i> Orígenes - Destinos
            </h3>
            <div class="card-tools">
              <button
                type="button"
                data-card-widget="collapse"
                data-toggle="tooltip"
                title="Collapse"
                class="btn btn-tool"
              >
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <label for="Ruta_info" class="col-md-4 col-sm-4 col-xs-6"
                ><b>Ruta: </b></label
              >
              <span
                id="Ruta_info"
                class="col-md-8 col-sm-8 col-xs-6 text-right"
                >{{ entidad_data.ruta ? entidad_data.ruta.nombre : "" }}</span
              >
            </div>
            <div class="row">
              <label for="Ruta_info" class="col-md-4 col-sm-4 col-xs-6"
                ><b>Tipo Ruta: </b></label
              >
              <span
                id="Ruta_info"
                class="col-md-8 col-sm-8 col-xs-6 text-right"
                v-if="entidad_data.ruta && entidad_data.ruta.tipo_ruta == 1"
                >Ruta Corta</span
              >
              <span
                id="Ruta_info"
                class="col-md-8 col-sm-8 col-xs-6 text-right"
                v-else
                >Ruta Larga</span
              >
            </div>
            <div class="row">
              <label for="Sitio_Cargue_info" class="col-md-4 col-sm-4 col-xs-6"
                ><b>Sitio Cargue: </b></label
              >
              <span
                id="Sitio_Cargue_info"
                class="col-md-8 col-sm-8 col-xs-6 text-right"
                >{{
                  entidad_data.ruta ? entidad_data.ruta.origen.nombre : ""
                }}</span
              >
            </div>
            <div class="row">
              <label
                for="Sitio_Descargue_info"
                class="col-md-4 col-sm-4 col-xs-6"
                ><b>Sitio Descargue: </b></label
              >
              <span
                id="Sitio_Descargue_info"
                class="col-md-8 col-sm-8 col-xs-6 text-right"
                >{{
                  entidad_data.ruta ? entidad_data.ruta.destino.nombre : ""
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <!-- Fechas Enturnes -->
      <div class="col-md-6 col-sm-12 col-xs-12" v-if="type_entidad == 'Viaje'">
        <div
          class="card card-outline collapsed-card"
          :class="
            entidad_data.trazas_fechas_viaje != null
              ? 'card-info'
              : 'card-danger'
          "
        >
          <div class="card-header pt-2 pb-2">
            <h3 class="card-title">
              <i class="fa fa-align-justify text-secondary"></i> Fechas Enturnes
            </h3>
            <div class="card-tools">
              <button
                type="button"
                data-card-widget="collapse"
                data-toggle="tooltip"
                title="Collapse"
                class="btn btn-tool"
              >
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <label for="API_Producto_info" class="col-md-4 col-sm-4 col-xs-6"
                ><b>Fecha enturne cargue: </b></label
              >
              <span
                id="FechaEnturneCargue_info"
                class="col-md-8 col-sm-8 col-xs-6 text-right"
                v-if="
                  entidad_data.trazas_fechas_viaje &&
                    entidad_data.trazas_fechas_viaje != null
                "
                >{{
                  entidad_data.trazas_fechas_viaje.fecha_enturne_cargue
                }}</span
              >
            </div>
            <div class="row">
              <label
                for="fecha_enturne_descargue"
                class="col-md-4 col-sm-4 col-xs-6"
                ><b>Fecha enturne descargue: </b></label
              >
              <span
                id="fecha_enturne_descargue"
                class="col-md-8 col-sm-8 col-xs-6 text-right"
                v-if="
                  entidad_data.trazas_fechas_viaje &&
                    entidad_data.trazas_fechas_viaje != null
                "
                >{{
                  entidad_data.trazas_fechas_viaje.fecha_enturne_descargue
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <!-- Div Unidad de transporte-->
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="card card-info card-outline collapsed-card">
          <div class="card-header pt-2 pb-2">
            <h3 class="card-title">
              <i class="fa fa-id-card text-secondary"></i> Unidad de Transporte
            </h3>
            <div class="card-tools">
              <button
                type="button"
                data-card-widget="collapse"
                data-toggle="tooltip"
                title="Collapse"
                class="btn btn-tool"
              >
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <label
                for="Identificacion_info"
                class="col-md-6 col-sm-6 col-xs-6"
                ><b>Empresa Transportadora: </b></label
              >
              <span
                id="Identificacion_info"
                class="col-md-6 col-sm-6 col-xs-6 text-right"
                >{{
                  type_entidad == "Viaje"
                    ? entidad_data.transportadora.razon_social
                    : entidad_data.det_solicitud_diaria.empresa.razon_social
                }}</span
              >
            </div>
            <div class="row">
              <!-- Información del Conductor -->
              <div class="form-group col-md-4 col-sm-6 col-xs-12 text-center">
                <span><strong>Conductor</strong></span>
                <div>
                  <span v-if="entidad_data.conductor"
                    >{{ entidad_data.conductor.nombres }}
                    {{ entidad_data.conductor.apellidos }}</span
                  >
                </div>
                <div>
                  <small
                    >Documento:
                    {{
                      entidad_data.conductor
                        ? entidad_data.conductor.numero_documento
                        : ""
                    }}</small
                  >
                </div>
                <div>
                  <small
                    >Tel:
                    {{
                      entidad_data.conductor
                        ? entidad_data.conductor.celular_principal
                        : ""
                    }}</small
                  >
                </div>
                <div
                  class="m-3"
                  v-if="
                    entidad_data.conductor &&
                      entidad_data.conductor.link_fotografia
                  "
                >
                  <a
                    :href="uri_docs + entidad_data.conductor.link_fotografia"
                    target="_blank"
                    ><img
                      :src="uri_docs + entidad_data.conductor.link_fotografia"
                      alt="Conductor"
                      class="rounded mx-auto d-block"
                      width="150"
                  /></a>
                </div>
              </div>
              <!-- Información del Vehículo -->
              <div class="form-group col-md-4 col-sm-6 col-xs-12 text-center">
                <span><strong>Vehículo</strong></span>
                <div>
                  <span>{{
                    entidad_data.vehiculo ? entidad_data.vehiculo.placa : ""
                  }}</span>
                </div>
                <div
                  class="m-3"
                  v-if="
                    entidad_data.vehiculo &&
                      entidad_data.vehiculo.link_fotografia
                  "
                >
                  <a
                    :href="uri_docs + entidad_data.vehiculo.link_fotografia"
                    target="_blank"
                    ><img
                      :src="uri_docs + entidad_data.vehiculo.link_fotografia"
                      alt="Vehículo"
                      class="rounded mx-auto d-block"
                      width="150"
                  /></a>
                </div>
              </div>
              <!-- Información del Vehículo -->
              <div
                v-if="entidad_data.remolque"
                class="form-group col-md-4 col-sm-6 col-xs-12 text-center"
              >
                <span><strong>Remolque</strong></span>
                <div>
                  <span>{{ entidad_data.remolque.placa }}</span>
                </div>
                <div class="m-3" v-if="entidad_data.remolque.link_fotografia">
                  <a
                    :href="uri_docs + entidad_data.remolque.link_fotografia"
                    target="_blank"
                    ><img
                      :src="uri_docs + entidad_data.remolque.link_fotografia"
                      alt="Remolque"
                      class="rounded mx-auto d-block"
                      width="150"
                  /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GestionInfoHidrocarburos",
  data() {
    return {
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
    };
  },
  props: {
    entidad_data: {
      type: Object,
    },
    type_entidad: {
      type: String,
    },
  },
};
</script>
